import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './assets/main.css'

// 优先读取 URL 中的 lang 参数，确保首屏也生效
try {
  const params = new URLSearchParams(window.location.search)
  const lang = params.get('lang')
  if (lang === 'en' || lang === 'zh') {
    i18n.global.locale = lang
    localStorage.setItem('locale', lang)
  }
} catch (e) {
  // 忽略
}

createApp(App)
  .use(router)
  .use(i18n)
  .mount('#app')
